/* eslint-disable react/require-default-props,react/no-array-index-key */
import React from 'react';
import PropTypes from 'prop-types';
import CSSModules from 'react-css-modules';
import ScaleInput from './ScaleInput';
import styles from './index.styl';

const ScaleRange = ({ name, list, selectedItem, onChange }) => (
  <div styleName="root">
    {list &&
      list.map((item, index) => (
        <ScaleInput
          key={`${name}-${index}`}
          id={`${name}-${index}`}
          label={item}
          name={name}
          value={item}
          opacity={index / list.length}
          defaultChecked={String(item) === String(selectedItem)}
          onChange={() => onChange(String(item))}
        />
      ))}
  </div>
);

ScaleRange.propTypes = {
  list: PropTypes.arrayOf(PropTypes.number).isRequired,
  name: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  selectedItem: PropTypes.number,
  onChange: PropTypes.func,
};

ScaleRange.propTypes = {
  onChange: () => {},
};

export default CSSModules(ScaleRange, styles, { allowMultiple: true });



// WEBPACK FOOTER //
// ./src/components/common/ScaleRange/index.jsx